import { Navigate, useLocation } from 'react-router-dom';

/** Redirects a pre-/app-migration bookmark or email link to its new /app/... location. */
export default function LegacyRedirect() {
  const location = useLocation();
  return <Navigate to={`/app${location.pathname}${location.search}`} replace />;
}
